import React from 'react'
import PropTypes from 'prop-types'
import { Size } from 'loyal-react'
import FeatureWrapper from '../FeatureWrapper'
import FeatureTitle from '../FeatureTitle'
import FeatureItems from '../FeatureItems'
import { Link } from 'react-router-dom'

const getSizes = SkuByType => {
  const _COR = SkuByType.filter(x => x.currentSku === true)[0].COR

  const listMap = SkuByType.filter(x => x.COR === _COR)

  return listMap.sort((a, b) => {
    var nameA = a.TAMANHO && a.TAMANHO.toLowerCase()
    var nameB = b.TAMANHO && b.TAMANHO.toLowerCase()
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  })
}

const SizeFeature = ({ SkuByType }) => (
  <FeatureWrapper>
    <FeatureTitle>Selecione o tamanho</FeatureTitle>
    <FeatureItems>
      {getSizes(SkuByType).map(size => {
        return size.TAMANHO && (
          <Link to={`/products/${size.sku}`} key={size.sku}>
            <Size
              id={size.sku}
              label={size.TAMANHO}
              name={size.sku}
              checked={size.currentSku}
              onChange={() => {}}
              labelClass={'pointer px-1'}
            />
          </Link>
        )
      })}
    </FeatureItems>
  </FeatureWrapper>
)

SizeFeature.propTypes = {
  SkuByType: PropTypes.array
}

export default SizeFeature



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/SizeFeature.js